import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class OwnershipTypeSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: false,
      msg: "",
      toastColor: "",
      ownershipTypes: [],
      editing: false,
      page: 0,
      size: 10,
      totalPages: 1,
      // Form state
      id: 0,
      name: "",
      activeStatus: "YES",
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchOwnershipTypes = this.fetchOwnershipTypes.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchOwnershipTypes(0, 10, token);
  }

  fetchOwnershipTypes(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getallownershiptype", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let ownershipTypes = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          ownershipTypes = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          ownershipTypes = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          ownershipTypes = [];
        }
        this.setState({
          ownershipTypes,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          ownershipTypes: [],
          totalPages: 1,
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load ownership types.",
          msg:
            error?.response?.data?.message || "Failed to load ownership types.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (s.editing) {
      if (!s.name || !s.name.trim()) {
        errors.name = "Ownership type name is required";
        valid = false;
      }
      if (!s.activeStatus || !s.activeStatus.trim()) {
        errors.activeStatus = "Active status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      id: this.state.id,
      name: this.state.name,
      activeStatus: this.state.activeStatus,
    };

    const self = this;
    axios
      .post(API + "/settings/ownershiptypesave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Ownership type saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            id: 0,
            name: "",
            activeStatus: "YES",
            editing: false,
            errors: {},
          });
          // Refetch data
          const currentPage = self.state.page;
          self.fetchOwnershipTypes(currentPage, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save ownership type.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save ownership type. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(ownershipType) {
    this.setState({
      id: ownershipType?.id || 0,
      name: ownershipType?.name || "",
      activeStatus: ownershipType?.activeStatus || "YES",
      editing: true,
      errors: {},
    }, this.validate);
  }

  handleCancelEdit() {
    this.setState({
      id: 0,
      name: "",
      activeStatus: "YES",
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchOwnershipTypes(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchOwnershipTypes(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Ownership Type Settings" />
          {divMsg}
          <div className="w-full grow px-5 h-[60%]">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="flex flex-col items-center w-full mt-2 pt-3 pb-2 h-full overflow-y-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="grid grid-cols-2 gap-x-8 gap-y-4 w-full max-w-5xl">
                  <div className="input-group">
                    <label className="input-group-text">Ownership Type Name</label>
                    <input
                      name="name"
                      className={`form-control ${
                        s.errors.name ? " !border-red-500" : ""
                      }`}
                      value={s.name}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.name && (
                      <span className="input-group-error">{s.errors.name}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.activeStatus}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex justify-center gap-8 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="flex gap-2 mb-2 items-baseline justify-between">
                  <h3 className="font-bold">Configured Ownership Types</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit(null)}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.ownershipTypes.length === 0 ? (
                  <div className="text-gray-500">No ownership types found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Active Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.ownershipTypes.map((ownershipType, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {ownershipType.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {ownershipType.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {ownershipType.activeStatus}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-success"
                                onClick={() => this.handleEdit(ownershipType)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="flex justify-center items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}